// a small "still working on it" spinner, used while a file is 
// being parsed (which is usually near-instant, but not always).

import React from 'react';
import './RendererStatus.css';

interface RendererStatusProps {
  label: string;
}

// Brief local-processing indicator (CSV/XLSX parsing, DOCX layout) — distinct
// from the shell's network-fetch skeleton, since this covers synchronous,
// usually sub-second, in-memory work rather than a download.
const RendererStatus: React.FC<RendererStatusProps> = ({ label }) => (
  <div className="renderer-status">
    <i className="fas fa-spinner fa-spin" aria-hidden="true" />
    <span>{label}</span>
  </div>
);

export default RendererStatus;
